import { gql } from 'apollo-angular';

export const GET_REPORTS = gql`
  query ($criteria: DashboardUrlsV2Criteria!) {
    dashboardUrlsV2(criteria: $criteria) {
      tenantId
      type
      url
      expiresAt
    }
  }
`;

export const DEBT_AGING_DASHBOARD = gql`
  query ($criteria: DebtAgingDashboardCriteria!) {
    debtAgingDashboard(criteria: $criteria) {
      url
    }
  }
`;
